module.exports = __webpack_public_path__ + "static/media/map-marker-alt.0656295e.svg";